export const lossLocation = [
  
];